// src/components/MessageBox.js
import React from "react";
import { Box } from "@mui/material";
import MessageIcon from "@mui/icons-material/Message";
import PropTypes from "prop-types";

const MessageBox = ({
  ticketData,
  handleChange,
  clearPreviousSuggestions,
  raiseTicket,
  displayAlertMessage,
  message,
}) => {
  return (
    <div>
      <Box sx={{ display: "flex", alignItems: "flex-start", mt: 1 }}>
        <MessageIcon />
        <textarea
          className="ticket-message"
          name="message"
          onClick={clearPreviousSuggestions}
          onChange={handleChange}
          onBlur={(event) => {
            raiseTicket(ticketData);
            displayAlertMessage(message.updatedMessage);
          }}
          style={{
            marginLeft: "8px",
            flex: 1,
            resize: "none",
            padding: "10px",
            width: "100%",
            height: "200px",
            outline: "none",
          }}
          placeholder="Description"
          value={ticketData.message}
          maxLength={1000}
        />
      </Box>
    </div>
  );
};

MessageBox.propTypes = {
  ticketData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  clearPreviousSuggestions: PropTypes.func.isRequired,
  raiseTicket: PropTypes.func.isRequired,
  displayAlertMessage: PropTypes.func.isRequired,
  message: PropTypes.object.isRequired,
};

export default MessageBox;
